import CWImage from '@/context/global/components/g00/g00-d00-g003-cw-image-fallback';
import IconAdd from '@/context/global/components/Icon/IconAdd';
import IconLock from '@/context/global/components/Icon/IconLock/IconLock';
import { useAuthStore } from '@/context/global/stores/authStore';
import { TSong } from '@/context/global/types/song';

type SearchSongItemProps = {
  song: TSong;
  onAdd?: (song: TSong) => void;
};

const SearchSongItem = ({ song, onAdd }: SearchSongItemProps) => {
  const { user } = useAuthStore();
  const isLocked = song.conditions === 2 && user?.badge === 3;
  return (
    <div className="hover:inset-ring-white hover:inset-ring-2 group mb-2 flex cursor-pointer items-center gap-4 rounded-2xl p-4 transition-all">
      {/* Thumbnail */}
      <div className="relative h-[72px] w-[72px] shrink-0 overflow-hidden rounded-[9px]">
        <CWImage
          fill
          src={song.coverUrl ?? ''}
          alt={song.title ?? ''}
          className="object-cover"
        />
      </div>

      {/* Song Info */}
      <div className="relative flex min-w-0 flex-1 flex-col justify-center">
        <p className="font-db-heavent truncate text-2xl font-bold text-white">
          {song.title}
        </p>
        <p className="font-db-heavent truncate text-xl text-[#B5B5B5]">{song.artist}</p>
        {isLocked && (
          <div className="absolute right-3 top-0 flex size-[26px] shrink-0 items-center justify-center rounded-full bg-[rgba(20,32,51,0.8)]">
            <IconLock className="size-4 text-ais-green" />
          </div>
        )}
      </div>

      {/* Add Button - always visible on mobile, visible on hover on desktop */}
      {!isLocked && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onAdd?.(song);
          }}
          className="flex h-12 w-12 shrink-0 cursor-pointer items-center justify-center rounded-full border-2 border-white bg-black/40 transition-opacity hover:border-ais-green md:group-hover:opacity-100"
          aria-label="Add to queue"
        >
          <IconAdd size={24} className="text-white hover:text-ais-green" />
        </button>
      )}
    </div>
  );
};

export default SearchSongItem;
